import { io, type Socket } from "socket.io-client"

/* v0.2 — Resolución de la URL del server: priorizamos VITE_DOMO_SERVER_URL
   (canónica), caemos a VITE_MMSOR_SERVER_URL (legacy) y por último al
   localhost:4000 del modo dev. Mientras Vercel tenga ambas vars o
   solo la legacy, el cliente sigue funcionando sin parchar. */
const SERVER_URL =
    import.meta.env.VITE_DOMO_SERVER_URL ??
    import.meta.env.VITE_MMSOR_SERVER_URL ??
    "http://localhost:4000"

let socket: Socket | null = null

export function connectSocket(token: string): Socket {
    if (socket?.connected) return socket
    socket?.disconnect()

    socket = io(SERVER_URL, {
        transports: ["websocket"],
        auth: { token },
        reconnection: true,
        reconnectionAttempts: 8,
        reconnectionDelay: 1000,
        reconnectionDelayMax: 5000,
        timeout: 10000,
    })

    return socket
}

export function getSocket(): Socket | null {
    return socket
}

export function disconnectSocket(): void {
    socket?.disconnect()
    socket = null
}

export const SERVER_URL_RUNTIME = SERVER_URL
